import React, { useRef, useEffect } from "react"

const AlbyQA = props => {
  const { widgetId = "", skuId = "", threadId = "" } = props

  const albyElementRef = useRef(null)
  const previousSkuId = useRef(skuId)

  useEffect(() => {
    const callSwitchProduct = async () => {
      if (
        skuId &&
        skuId !== previousSkuId.current &&
        albyElementRef.current?.switchProduct
      ) {
        try {
          await albyElementRef.current.switchProduct(skuId)
          previousSkuId.current = skuId
        } catch (error) {
          console.error(error)
        }
      } else if (skuId !== previousSkuId.current) {
        previousSkuId.current = skuId
      }
    }

    const timer = setTimeout(callSwitchProduct, 100)
    return () => clearTimeout(timer)
  }, [skuId])

  return (
    <div className="alby-qa-container">
      <alby-generative-qa
        ref={albyElementRef}
        widget-id={widgetId}
        product-id={skuId}
        thread-id={threadId}
      />
    </div>
  )
}

export default React.memo(AlbyQA)
